import Message from './message'
import Container from './container'
import Table from './table'
import Modal from './modal'
import Pagination from './pagination'
import Popup from './popup'
import Dialog from './dialog'
import Select from './select'
import Dropdown from './dropdown'
import Upload from './upload'
import BatchAddGoods from './BatchAddGoods'

const components = {
    Container,
    Table,
    Modal,
    Pagination,
    Select,
    Dropdown,
    Upload,
    BatchAddGoods
}

const install = function (Vue, options) {
    Object.keys(components).forEach((key) => {
        Vue.component(key, components[key])
    })

    Vue.prototype.$Message = Message
    Vue.prototype.$Popup = Popup
    Vue.prototype.$Dialog = Dialog
    Vue.prototype.$BatchAddGoods = BatchAddGoods
}

export default install



// WEBPACK FOOTER //
// ./src/components/index.js